<ng-template #globalErrorPageContent>
  @if (errorType() === 'shm') {
    <span> L'accès est réservé au service habilitation métier </span>
  } @else {
    <span>L'accès est réservé aux consultants </span>
  }

  <br />

  <oui-button (click)="logOut()">Se déconnecter</oui-button>
</ng-template>
